import React from 'react';
import { Clock, Book, BarChart2, Target, Award, Users } from "lucide-react";

// Mock stats data
const stats = [
  { title: "Platform Time", value: "42h 15m", description: "Total time spent on platform", icon: Clock, trend: "+8% from last month" },
  { title: "Courses Completed", value: "7", description: "Total courses completed", icon: Book, trend: "+2 this month" },
  { title: "Tools Used", value: "12", description: "Different tools utilized", icon: BarChart2, trend: "Most used: AEO Analyzer" },
  { title: "Resources Saved", value: "34", description: "Items in your vault", icon: Target, trend: "+5 new items" },
  { title: "Achievements", value: "8", description: "Badges earned", icon: Award, trend: "2 badges available" },
  { title: "Team Members", value: "3", description: "Connected accounts", icon: Users, trend: "2 pending invites" },
];

export function AccountStats() {
  return (
    <div className="overflow-hidden rounded-2xl border border-white/[0.07] bg-og01-card p-6">
      <div className="mb-5">
        <h3 className="font-heading text-[20px] text-og01-text">Usage Statistics</h3>
        <p className="mt-1 text-[13px] text-og01-text-secondary">Your platform activity and engagement metrics</p>
      </div>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {stats.map((stat, index) => {
          const Icon = stat.icon;
          return (
            <div key={index} className="rounded-[13px] border border-white/[0.07] bg-[#0F0F18] p-5">
              <div className="mb-3.5 flex items-center gap-2.5 text-[13px] text-og01-text-secondary">
                <span className="grid h-[30px] w-[30px] flex-none place-items-center rounded-lg" style={{ background: "color-mix(in srgb, var(--accent, #8B5CF6) 14%, transparent)" }}>
                  <Icon className="h-4 w-4" style={{ color: "var(--accent, #8B5CF6)" }} />
                </span>
                {stat.title}
              </div>
              <div className="mb-1.5 font-heading text-[34px] leading-none text-og01-text">{stat.value}</div>
              <div className="text-[12.5px] text-og01-text-muted">{stat.description}</div>
              <div className="mt-2 text-[12.5px]" style={{ color: "var(--accent, #8B5CF6)" }}>{stat.trend}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
